<template>
    <div class="header" id="header" ref:header>
     <a href="http://www.ishowchina.com" target="_blank"><img src="./images/chebanlvlogo2.png" class="logo"/></a> 
      <ul>
        <li>
          <a href="http://chebanlv.ishowchina.com/trackcloud/track.htm" target="_blank">轨迹云</a>
        </li>
        <li>
          <a href="http://v.ishowchina.com/" target="_blank">大数据可视化</a>
        </li>
        <li>
        	<a href="http://clw.ishowchina.com:89/mygpsonline" target="_blank">位置服务平台</a>
        </li>
      </ul>
    </div>
</template>
<style lang="less" rel="stylesheet/less">
  .header{
    height: 93px;
    background: #eff8fd;
    position: relative;
    z-index: 2;
    .logo {
      position: absolute;
      left: 150px;
      top: 20px;
     }
    ul {
      position: absolute;
      left: 480px;
      top: 0;
      line-height: 93px;
      li{
        float: left;
        list-style: none;
        margin-right: 50px;
        a {
          text-decoration: none;
          color: #164f92;
          font-weight: bold;
          font-size: 1.6rem;
        }
      }
    }
  }

</style>
<script>
  export default {
    data () {
      return {
        msg: 'hello vue'
      }
    },
    components: {

    }
  }
</script>



// WEBPACK FOOTER //
// header.vue?8a410f72